






import Icon from '../../../../shared/components/Icon.vue';
import { PropType } from 'vue';
import { iconClassEnum } from '../../../../shared/enums/iconClassEnum';

export default {
  components: { Icon },
  props: {
    icon: { type: String as PropType<iconClassEnum>, default: null },
    type: { type: String, required: true },
  },
};
